import React, { useState } from "react";
import PrevPage from "../../../components/Pagination/PrevPage";
import NumberPage from "../../../components/Pagination/NumberPage";
import NextPage from "../../../components/Pagination/NextPage";
import SelectRows from "../../Pagination/SelectRows";
import { LIMIT_OPTIONS } from "../constrant/leasing.ct.options";
import { prePareQueryRequest } from "components/Leasing/utils/leasing.u";
import { useSelector } from "react-redux";
import _ from "lodash";

function FootagePagination({
  countRecords,
  leasings = [],
  formQuery,
  setFormQuery,
  refetch,
  onChangeSelect,
  pageType,
  setPageType,
  pageIndex,
  setPageIndex,
  searchBy,
  lastItem = null,
  primaryKey = "",
}) {
  const searchBar = useSelector((state) => state.searchBar);
  const totalPage = Math.ceil(countRecords / formQuery?.Limit?.value);

  const paginationPages = new Array(1)?.fill(0)?.slice(0, 1);

  const onChangeLimit = async (e) => {
    setPageIndex(0);
    let newQuery = {
      ...formQuery,
      Limit: e,
    };
    delete newQuery?.ExclusiveStartKey;
    setFormQuery(newQuery);
    await refetch(newQuery);
  };

  const onClickPrevPage = async () => {
    let newQuery = {
      ...formQuery,
      Limit: formQuery.Limit,
      ScanIndexForward: true,
    };
    newQuery = {
      ...newQuery,
      ExclusiveStartKey: getExclusiveStartKey(0),
    };
    setPageIndex((prev) => prev - 1);
    setPageType("PREV");
    await refetch(newQuery, true, true);
  };

  const onClickNextPage = async () => {
    const lastIndex = leasings.length - 1;
    const newQuery = {
      ...formQuery,
      ScanIndexForward: false,
      Limit: formQuery.Limit,
      ExclusiveStartKey: getExclusiveStartKey(lastIndex),
    };
    setPageIndex((prev) => prev + 1);
    setPageType("NEXT");
    await refetch(newQuery);
  };

  const getExclusiveStartKey = (index) => {
    const prePareQuery = prePareQueryRequest(
      _.cloneDeep(formQuery),
      searchBy,
      searchBar
    );
    if (prePareQuery.name) {
      return `${primaryKey}=${leasings[index][primaryKey]}&createdAt=${leasings[index].createdAt}&name=${leasings[index].name}`;
    } else if (prePareQuery.requestamount) {
      return `${primaryKey}=${leasings[index][primaryKey]}&createdAt=${leasings[index].createdAt}&amount=${leasings[index].amount}`;
    } else if (prePareQuery.phone_number) {
      return `${primaryKey}=${leasings[index][primaryKey]}&createdAt=${leasings[index].createdAt}&phone_number=${leasings[index].phone_number}`;
    } else if (prePareQuery.citizenid) {
      return `${primaryKey}=${leasings[index][primaryKey]}&createdAt=${leasings[index].createdAt}&citizenid=${leasings[index].citizenid}`;
    } else if (prePareQuery.adminName) {
      return `${primaryKey}=${leasings[index][primaryKey]}&createdAt=${leasings[index].createdAt}&adminName=${leasings[index].adminName}`;
    }
    return `${primaryKey}=${leasings[index][primaryKey]}&createdAt=${leasings[index].createdAt}&isCreated=true`;
  };

  return (
    <div className=" flex justify-between gap-4 mb-1">
      <nav
        className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
        aria-label="Pagination"
      >
        <PrevPage canPreviousPage={pageIndex !== 0} onClick={onClickPrevPage} />
        {paginationPages.map((_, i) => {
          return <NumberPage number={pageIndex} pageIndex={pageIndex} />;
        })}
        <NextPage onClick={onClickNextPage} canNextPage={true} />
      </nav>
      <div className="w-24 flex">
        <SelectRows
          pageSize={formQuery?.Limit}
          onChange={onChangeLimit}
          options={LIMIT_OPTIONS}
        />
      </div>
    </div>
  );
}

export default FootagePagination;
